/*eslint-disable max-len*/
import React, { Component } from 'react';
import * as MaterialUI from '@material-ui/core';

const { SvgIcon } = MaterialUI;

class DefaultAvatar extends Component {
	constructor(props) {
		super(props);
		this.props = props;
	}

	render() {
		return (
			<SvgIcon width="96" height="96" viewBox="0 0 96 96" {...(this.props)}>
				<rect x="0" y="0" width="96" height="96" fill="#c5c5c5" />
				<circle cx="48" cy="38.5" r="22.5" fill="#fff" />
				<ellipse cx="48" cy="96" rx="37.5" ry="39.5" fill="#fff" />
			</SvgIcon>
		);
	}
}

export default DefaultAvatar;



// WEBPACK FOOTER //
// ./src/components/icons/defaultAvatar.js